export const FOCUS_INPUT = 'onboarding/sharedForm/FOCUS_INPUT'
export const BLUR_INPUT = 'onboarding/sharedForm/BLUR_INPUT'
